module.exports = {
      id: "icon-audio-fb-usage",
      viewBox: "0 0 25.21 25.21",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-audio-fb",
      toString: function () {
        return this.url;
      }
    }